import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import {
  CommonEn,
  OffersManagementEn,
  SmartWalletEn,
  TokenSelectorEn,
  TermsAndAgreementsEn,
  WalletEn,
  TradeEn,
  SmtRewardsEn,
  GoldBundleEn,
  CarbonBundleEn,
} from './locales/en'

const resources = {
  en: {
    common: CommonEn,
    offersManagement: OffersManagementEn,
    smartWallet: SmartWalletEn,
    tokenSelector: TokenSelectorEn,
    termsAndAgreements: TermsAndAgreementsEn,
    wallet: WalletEn,
    trade: TradeEn,
    smtRewards: SmtRewardsEn,
    goldBundles: GoldBundleEn,
    carbonBundles: CarbonBundleEn,
  },
}

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
